import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { Logo } from './ui/Logo';
import { cn } from '../utils/cn';
import { useLanguage } from '../context/LanguageContext';
export function Navbar() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const navLinks = [{
    name: t.nav.entorno,
    href: '#entorno'
  }, {
    name: t.nav.calidades,
    href: '#calidades'
  }, {
    name: t.nav.pisoPiloto,
    href: '#zonas-comunes'
  }, {
    name: t.nav.disponibilidad,
    href: '#disponibilidad'
  }, {
    name: t.nav.promotora,
    href: '#quienes-somos'
  }, {
    name: t.nav.contacto,
    href: '#contacto'
  }];
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (href: string) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300', isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6')} data-id="element-273" data-mp="vmfsuemxs2s">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-274" data-mp="34debojvw6w69">
        <a href="#" onClick={e => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} className="transition-transform hover:scale-105" data-id="element-275" data-mp="39bpkqsed52nf">
          <Logo variant={isScrolled ? 'dark' : 'light'} data-id="element-276" data-mp="2wa3zed12v2pt" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-277" data-mp="3b35qln0qki43">
          <ul className="flex items-center gap-6" data-id="element-278" data-mp="3631dm6z1e5im">
            {navLinks.map(link => <li key={link.name} data-id="element-279" data-mp="2idgpzarxuk30">
                <a href={link.href} onClick={e => {
              e.preventDefault();
              scrollTo(link.href);
            }} className={cn('text-sm font-medium transition-opacity hover:opacity-70', isScrolled ? 'text-navy/80' : 'text-white/90 drop-shadow-sm')} data-id="element-280" data-mp="2icnp2qfnuoss">
                  {link.name}
                </a>
              </li>)}
          </ul>

          {/* Desktop Lang Selector */}
          <div className="flex items-center gap-2 border-l border-white/20 pl-6 ml-2" data-id="element-281" data-mp="a6vcyyz5zumj">
            <button onClick={() => setLang('es')} className={cn('text-sm font-bold transition-colors', lang === 'es' ? isScrolled ? 'text-navy' : 'text-white' : isScrolled ? 'text-navy/40' : 'text-white/50')} data-id="element-282" data-mp="f56mf8ljs348">
              es
            </button>
            <span className={cn('text-sm', isScrolled ? 'text-navy/20' : 'text-white/20')} data-id="element-283" data-mp="k3hy7oveknp3">
              |
            </span>
            <button onClick={() => setLang('en')} className={cn('text-sm font-bold transition-colors', lang === 'en' ? isScrolled ? 'text-navy' : 'text-white' : isScrolled ? 'text-navy/40' : 'text-white/50')} data-id="element-284" data-mp="1btw4p0136xqq">
              en
            </button>
          </div>

          <Button variant={isScrolled ? 'primary' : 'secondary'} onClick={() => scrollTo('#contacto')} data-id="element-285" data-mp="3b25syn99qfnq">
            {t.nav.solicitarInfo}
          </Button>
        </nav>

        {/* Mobile Toggle + Lang Selector (outside the menu) */}
        <div className="lg:hidden flex items-center gap-3" data-id="element-286" data-mp="6opr5mbnwcfl">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2" data-id="element-287" data-mp="1wfttl87wa3a">
            {isMobileMenuOpen ? <X className={cn('w-6 h-6', isScrolled ? 'text-navy' : 'text-white')} data-id="element-288" data-mp="3tz7830wjdw5e" /> : <Menu className={cn('w-6 h-6', isScrolled ? 'text-navy' : 'text-white')} data-id="element-289" data-mp="pkpeukxlwttd" />}
          </button>

          <div className="flex items-center gap-1.5" data-id="element-290" data-mp="2dahiq6zwf9wo">
            <button onClick={() => setLang('es')} className={cn('text-sm font-bold transition-colors', lang === 'es' ? isScrolled ? 'text-navy' : 'text-white' : isScrolled ? 'text-navy/40' : 'text-white/50')} data-id="element-291" data-mp="2h9gn9qhpx4nl">
              es
            </button>
            <span className={cn('text-sm', isScrolled ? 'text-navy/20' : 'text-white/20')} data-id="element-292" data-mp="34zt0ngvqftlk">
              |
            </span>
            <button onClick={() => setLang('en')} className={cn('text-sm font-bold transition-colors', lang === 'en' ? isScrolled ? 'text-navy' : 'text-white' : isScrolled ? 'text-navy/40' : 'text-white/50')} data-id="element-293" data-mp="3exqqu9x5k0gt">
              en
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100" data-id="element-294" data-mp="1xknone9h354w">
          <nav className="flex flex-col p-6 gap-4" data-id="element-295" data-mp="1tkdhvzduwaoz">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
          e.preventDefault();
          scrollTo(link.href);
        }} className="text-navy font-medium py-3 border-b border-gray-50" data-id="element-296" data-mp="27jn0f5pjbgw4">
                {link.name}
              </a>)}

            <Button className="mt-4 w-full h-12" onClick={() => scrollTo('#contacto')} data-id="element-297" data-mp="2jue2kzpwu9v2">
              {t.nav.solicitarInfo}
            </Button>
          </nav>
        </div>}
    </header>;
}